// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3aQGW","footer":"ModalInfo_footer__1vyjK"};